module.exports = __webpack_public_path__ + "img/logo-1.befe1aff.jpg";